const snackConst = {};
const otpRegex = /^\d{6}$/;
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const passwordRegex =
  /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,}$/;

const requestType = {
  POST: "post",
  GET: "get",
  PUT: "put",
  DELETE: "delete",
};

const endPoints = {
  // Authentication Endpoints
  adminCreate: "/admin/create",
  adminLogin: "/admin/login",
  passwordChange: "/admin/profile/change-password",

  //Customer EndPoint
  getAllCustomer: "/admin/customers/fetch",
  userStatusUpdate: "/user/update-profile",

  //Provider Endpoint
  getAllProvider: "/admin/providers/fetch",

  //category
  getCategory: "/admin/category/fetch",
  createCategory: "/admin/category/create",
  updateCategory: "/admin/category/update",
  deleteCategory: "/admin/category/delete",

  //jobtitle
  getJobTitle: "/admin/job-title/fetch",
  createJobTitle: "/admin/job-title/create",
  updateJobTitle: "/admin/job-title/update",
  deleteJobTitle: "/admin/job-title/delete",

  //FAQ

  fetchFaq: "/admin/faq/fetch",
  createFaq: "/admin/faq/create",
  updateFaq: "/admin/faq/update",
  deleteFaq: "/admin/faq/delete",

  //Promo
  fetchPromo: "/admin/promo/fetch",
  createPromo: "/admin/promo/create",
  updatePromo: "/admin/promo/update",
  deletePromo: "/admin/promo/delete",

  //notification
  getNotification: "/admin/notification/fetch",
  createNotification: "/admin/notification/create",
  updateNotification: "/admin/notification/update",
  deleteNotification: "/admin/notification/delete",

  //jobs
  getJobs: "/admin/group-jobs",
  getJobDetails: "/admin/group-job/profiles",
  getJobId: "/admin/get-assignmentId",
  getJobById: "/admin/group-jobs",
  updateJobByAdmin: "/admin/group-jobs/update",
  assingJob: "/admin/assign-jobs",
  unAssingJob: "/admin/unassign-jobs",

  //admin
  adminData: "/admin/profile/fetch",

  //Dashboard
  getDashboard: "/admin/dashboard/fetch",
  getSettings: "/admin/settings/fetch",
  updateSettings: "/admin/settings/update",
};

export {
  emailRegex,
  endPoints,
  otpRegex,
  passwordRegex,
  requestType,
  snackConst,
};
